export default {"src":"/_next/static/media/Assist.43fed40e.svg","height":41,"width":40};